import React, { useState } from 'react';
import { Row, Col, UncontrolledTooltip } from 'reactstrap';

const QuoteItemGroupNameWithValidation = ({ group }) => {
    const childrenWithErrors = group.items.filter(x => x.validationErrors.filter(err => err.severity === "error").length > 0)
    const childrenWithWarnings = group.items.filter(x => x.validationErrors.filter(err => err.severity === "warning").length > 0)

    const allChildrenAreValid = childrenWithErrors.length === 0 && childrenWithWarnings.length === 0;

    const iconClassName = childrenWithErrors.length > 0 ? "bi-x-circle text-danger mx-2" :
        childrenWithWarnings.length > 0 ? "bi-exclamation-triangle text-warning mx-2" :
            "bi-square mx-2" // This case won't be used since we hide the icon when all are valid

    return (
        <Row className="g-0 flex-nowrap align-items-center w-100">
            <Col xs="auto">
                <i id={`group${group.id}`} className={`bi ${iconClassName}`} style={{ visibility: !allChildrenAreValid ? "visible" : "hidden" }}></i>
                <UncontrolledTooltip
                    placement="top"
                    target={`group${group.id}`}
                    className="align-left"
                    innerClassName="tooltip-inner-custom"
                >
                    {childrenWithErrors.length > 0 && (<div>
                        <strong>The following items have errors:</strong>
                        <ul>
                            {childrenWithErrors.map(x =>
                                <li key={x.guid}>
                                    {x.internalName}
                                </li>
                            )}
                        </ul>
                    </div>
                    )}
                    {childrenWithWarnings.length > 0 && (<div className={childrenWithErrors.length > 0 ? "mt-4" : ""}>
                        <strong>The following items have warnings:</strong>
                        <ul>
                            {childrenWithWarnings.map(x =>
                                <li key={x.guid}>
                                    {x.internalName}
                                </li>
                            )}
                        </ul>
                    </div>
                    )}
                    {/* Inline styles for the tooltip body */}
                    <style>
                        {`
                            .tooltip-inner-custom {
                                max-width: 600px !important;
                                background-color: #dc3545 !important;
                                color: rgba(234, 242, 251, 0.78);
                                border: 1px solid #dc3545 !important;
                                padding: 0.5rem;
                                font-weight: 500;
                                text-align: left;
                                white-space: normal; /* allow wrapping */
                            }
                        `}
                    </style>
                </UncontrolledTooltip>
            </Col>
            <Col>
                <span>{group.description}</span>
            </Col>
            {group.notes && group.notes !== null && group.notes !== "" &&
                <Col xs="auto">
                    <i className="bi bi-file-earmark-fill p-1" style={{ marginLeft: '12px' }} id={'Tooltip-' + group.id}></i>
                    <UncontrolledTooltip
                        placement="top"
                        target={'Tooltip-' + group.id}
                    >
                        {group.notes}
                    </UncontrolledTooltip>
                </Col>
            }
        </Row>
    );
};

export default QuoteItemGroupNameWithValidation;
